import styled from 'styled-components';

const Root = styled.div`
  height: 100%;
  overflow-x: hidden;
  border-left: 1px solid #d9d9d9;
`;

export { Root };
